'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var d3Array = require('d3-array');
var scale = require('@visx/scale');
var dateFns = require('date-fns');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var classNames = require('classnames');
var styles = require('@mui/material/styles');
var locale = require('date-fns/locale');
var d3TimeFormat = require('d3-time-format');
var shape = require('@visx/shape');
var axis = require('@visx/axis');
var grid = require('@visx/grid');
var event = require('@visx/event');
var tooltip = require('@visx/tooltip');
var clipPath = require('@visx/clip-path');
var curve = require('@visx/curve');
var threshold = require('@visx/threshold');
var gradient = require('@visx/gradient');
var group = require('@visx/group');
var utilsIsUniqueDate = require('@intoto-dev/utils-is-unique-date');
var brush = require('@visx/brush');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function isMissing(datum) {
    return 'missing' in datum && datum.missing;
}
function isPredicted(datum) {
    return 'predicted' in datum && datum.predicted;
}

function createYScale(plot, height, padding) {
    if (padding === void 0) { padding = 0; }
    var values = plot.data.map(function (datum) { return datum.value; });
    var minValues = plot.data.map(function (datum) { return (isPredicted(datum) ? datum.minValue : datum.value); });
    var maxValues = plot.data.map(function (datum) { return (isPredicted(datum) ? datum.maxValue : datum.value); });
    var yScaleRange = [padding, height + padding];
    var max = Math.max.apply(Math, __spreadArray(__spreadArray(__spreadArray([], values, false), minValues, false), maxValues, false));
    var min = typeof plot.bottom !== 'undefined'
        ? plot.bottom
        : Math.min.apply(Math, __spreadArray(__spreadArray(__spreadArray([], values, false), minValues, false), maxValues, false));
    var domainPadding = (max - min) * 0.2;
    var domainPaddingBottom = typeof plot.bottom !== 'undefined' ? 0 : domainPadding;
    return scale.scaleLinear({
        domain: plot.domain || [
            max + domainPadding,
            min - domainPaddingBottom,
        ],
        range: yScaleRange,
        round: true,
    });
}
function createXScale(dates, width) {
    if (width === void 0) { width = 0; }
    if (dates.length < 2) {
        throw new Error('Too little dates given');
    }
    return scale.scaleTime({
        domain: d3Array.extent(dates),
        range: [0, width],
        round: true,
    });
}

var match = /Z$|([+-])[0-2][0-9]:[0-5][0-9]$/;
function getTimezoneOffset(date) {
    var matches = date.match(match);
    // if timezone is UTC
    if (matches === null || matches[0] === 'Z') {
        return 0;
    }
    var isPositive = matches[1] === '+';
    var hours = parseInt(matches[0].substr(1, 2), 10);
    var minutes = parseInt(matches[0].substr(4, 2), 10);
    return ((hours * 60) + minutes) * (isPositive ? -1 : 1);
}
function shiftDate(date) {
    var offset = getTimezoneOffset(date);
    if (offset === 0) {
        return date;
    }
    var localOffset = new Date(date).getTimezoneOffset();
    var shift = localOffset - offset;
    return dateFns.addMinutes(new Date(date), shift).toISOString();
}
function shiftSeriesDates(series) {
    return series.map(function (s) {
        var data = s.data;
        return __assign(__assign({}, s), { data: data.map(function (d) { return (__assign(__assign({}, d), { date: shiftDate(d.date) })); }) });
    });
}

function tickFormat(_a, tick) {
    var unit = _a.unit, _b = _a.formatValue, formatValue = _b === void 0 ? function (value) { return value; } : _b;
    return unit ? "".concat(formatValue(tick)).concat(unit) : formatValue(tick).toString();
}

var defaultColors = ['#CE1836', '#1F81C6', '#A3A948', '#EDB92E'];
function colorByIndex(index) {
    return defaultColors[index % defaultColors.length];
}

var dateTime$1 = "%x, %X";
var date$1 = "%-m/%-d/%Y";
var time$1 = "%-I:%M:%S %p";
var periods$1 = [
	"AM",
	"PM"
];
var days$1 = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday"
];
var shortDays$1 = [
	"Sun",
	"Mon",
	"Tue",
	"Wed",
	"Thu",
	"Fri",
	"Sat"
];
var months$1 = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
var shortMonths$1 = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];
var enUS = {
	dateTime: dateTime$1,
	date: date$1,
	time: time$1,
	periods: periods$1,
	days: days$1,
	shortDays: shortDays$1,
	months: months$1,
	shortMonths: shortMonths$1
};

var dateTime = "%A den %d. %B %Y %X";
var date = "%d.%m.%Y";
var time = "%H:%M:%S";
var periods = [
	"AM",
	"PM"
];
var days = [
	"søndag",
	"mandag",
	"tirsdag",
	"onsdag",
	"torsdag",
	"fredag",
	"lørdag"
];
var shortDays = [
	"søn",
	"man",
	"tir",
	"ons",
	"tor",
	"fre",
	"lør"
];
var months = [
	"januar",
	"februar",
	"mars",
	"april",
	"mai",
	"juni",
	"juli",
	"august",
	"september",
	"oktober",
	"november",
	"desember"
];
var shortMonths = [
	"jan",
	"feb",
	"mars",
	"apr",
	"mai",
	"juni",
	"juli",
	"aug",
	"sep",
	"okt",
	"nov",
	"des"
];
var nbNO = {
	dateTime: dateTime,
	date: date,
	time: time,
	periods: periods,
	days: days,
	shortDays: shortDays,
	months: months,
	shortMonths: shortMonths
};

var locales = {
    en: enUS,
    nb: nbNO,
};

function valueInThreshold(value, threshold, thresholdDirection) {
    if (thresholdDirection === void 0) { thresholdDirection = 'up'; }
    return (value > threshold && thresholdDirection === 'up')
        || (value < threshold && thresholdDirection === 'down');
}
function hasValueInThreshold(data, threshold, thresholdDirection) {
    if (thresholdDirection === void 0) { thresholdDirection = 'up'; }
    if (typeof threshold === 'undefined') {
        return false;
    }
    return data.some(function (datum) { return valueInThreshold(datum.value, threshold, thresholdDirection); });
}

var AxisLeft = function AxisLeft(_a) {
    var plot = _a.plot, height = _a.height, yScale = _a.yScale, defaultLabelWidth = _a.defaultLabelWidth;
    var tickHeight = 30;
    return (jsxRuntime.jsx("svg", __assign({ width: plot.labelWidth || defaultLabelWidth, height: height }, { children: jsxRuntime.jsx(axis.AxisLeft, { scale: yScale, left: plot.labelWidth || defaultLabelWidth, tickFormat: function (tick) { return tickFormat(plot, tick.valueOf()); }, numTicks: Math.floor(height / tickHeight) }) })));
};

function separateSeriesData(data, condition) {
    return data
        .reduce(function (acc, item) {
        var lastList = acc[acc.length - 1];
        var lastItem = lastList && lastList[lastList.length - 1];
        var previousMatched = lastItem && condition(lastItem);
        // if previous item matched, but new one doesn't: create new list
        if (previousMatched !== condition(item)) {
            return __spreadArray(__spreadArray([], acc, true), [
                [item],
            ], false);
        }
        // add item to last list condition didn't change
        var newList = __spreadArray([], acc, true);
        newList[newList.length - 1] = __spreadArray(__spreadArray([], newList[newList.length - 1], true), [item], false);
        return newList;
    }, []);
}
function separateSeriesDataOnMissing(data) {
    return separateSeriesData(data, isMissing);
}

var SplitLine = function SplitLine(_a) {
    var keyRef = _a.keyRef, color = _a.color, seriesData = _a.seriesData, xScale = _a.xScale, yScale = _a.yScale, _b = _a.curve, curve$1 = _b === void 0 ? curve.curveBasis : _b, _c = _a.area, area = _c === void 0 ? false : _c;
    var flatData = react.useMemo(function () { return seriesData
        .reduce(function (acc, plot) { return __spreadArray(__spreadArray([], acc, true), plot, true); }, []); }, [seriesData]);
    var hasPredictedData = react.useMemo(function () { return flatData.some(isPredicted); }, [flatData]);
    var areaProps = {
        fill: color,
        fillOpacity: 0.15,
    };
    var hasMissingData = flatData.some(isMissing);
    var clipPathRect = react.useCallback(function (plot, index, otherPlots, missing) {
        if (missing === void 0) { missing = true; }
        if (plot.some(function (p) { return isMissing(p) === missing; })) {
            var from = xScale(new Date(plot[plot.length - 1].date));
            var to = xScale(otherPlots[index - 1]
                ? new Date(otherPlots[index - 1][otherPlots[index - 1].length - 1].date)
                : new Date(plot[0].date));
            return (jsxRuntime.jsx("rect", { y: 0, x: from, width: to - from, height: "100%" }, "".concat(keyRef, "_missing_rect_").concat(from)));
        }
        return null;
    }, [keyRef, xScale]);
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [hasPredictedData && (jsxRuntime.jsx(threshold.Threshold, { id: keyRef, data: flatData, x: function (datum) { return xScale(new Date(datum.date)); }, y0: function (datum) { return (isPredicted(datum) ? yScale(datum.minValue) : yScale(datum.value)); }, y1: function (datum) { return (isPredicted(datum) ? yScale(datum.maxValue) : yScale(datum.value)); }, curve: curve$1, clipAboveTo: 0, clipBelowTo: 3000, belowAreaProps: areaProps, aboveAreaProps: areaProps })), hasMissingData && (jsxRuntime.jsxs("g", __assign({ clipPath: "url(#".concat(keyRef, "_missing_data)") }, { children: [jsxRuntime.jsx(clipPath.ClipPath, __assign({ id: "".concat(keyRef, "_missing_data") }, { children: seriesData.map(function (plot, index, otherPlots) { return clipPathRect(plot, index, otherPlots); }) })), area && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(gradient.LinearGradient, { id: "".concat(keyRef, "_missing_area_gradient"), from: color, to: color, fromOpacity: 0.5, toOpacity: 0 }), jsxRuntime.jsx(shape.Area, { curve: curve$1, data: flatData, x: function (datum) { return xScale(new Date(datum.date)); }, y0: function (datum) { return yScale(datum.value); }, y1: function () { return yScale(Math.min.apply(Math, yScale.domain())); }, fill: "url(#".concat(keyRef, "_missing_area_gradient)") })] })), jsxRuntime.jsx(shape.LinePath, { curve: curve$1, data: flatData, x: function (datum) { return xScale(new Date(datum.date)); }, y: function (datum) { return yScale(datum.value); }, stroke: color, strokeWidth: 1.8, strokeDasharray: "2, 4", strokeOpacity: 1 })] }))), jsxRuntime.jsxs("g", __assign({ clipPath: "url(#".concat(keyRef, "_data)") }, { children: [jsxRuntime.jsx(clipPath.ClipPath, __assign({ id: "".concat(keyRef, "_data") }, { children: seriesData
                            .map(function (plot, index, otherPlots) { return clipPathRect(plot, index, otherPlots, false); }) })), area && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(gradient.LinearGradient, { id: "".concat(keyRef, "_area_gradient"), from: color, to: color, fromOpacity: 0.75, toOpacity: 0.1 }), jsxRuntime.jsx(shape.Area, { curve: curve$1, data: flatData, x: function (datum) { return xScale(new Date(datum.date)); }, y0: function (datum) { return yScale(datum.value); }, y1: function () { return yScale(Math.min.apply(Math, yScale.domain())); }, fill: "url(#".concat(keyRef, "_area_gradient)") })] })), jsxRuntime.jsx(shape.LinePath, { curve: curve$1, data: flatData, x: function (datum) { return xScale(new Date(datum.date)); }, y: function (datum) { return yScale(datum.value); }, stroke: color, strokeWidth: 1.8, strokeOpacity: 1 })] }))] }));
};

var Line = function Line(_a) {
    var keyRef = _a.keyRef, plot = _a.plot, xScale = _a.xScale, yScale = _a.yScale, _b = _a.index, index = _b === void 0 ? 0 : _b;
    var seriesData = separateSeriesDataOnMissing(plot.data);
    var color = plot.color || colorByIndex(index);
    var hasThresholdData = hasValueInThreshold(plot.data, plot.threshold, plot.thresholdDirection);
    var cutOff = yScale(plot.threshold || 0);
    var padding = 1;
    var splitLineProps = {
        seriesData: seriesData,
        xScale: xScale,
        yScale: yScale,
        curve: plot.curve,
    };
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [typeof plot.threshold !== 'undefined' && hasThresholdData && (jsxRuntime.jsxs("g", __assign({ clipPath: "url(#".concat(plot.key, "_threshold_clip)") }, { children: [jsxRuntime.jsx(clipPath.RectClipPath, { id: "".concat(plot.key, "_threshold_clip"), width: "100%", height: plot.thresholdDirection === 'up' ? cutOff - padding : '100%', y: plot.thresholdDirection === 'up' ? 0 : cutOff - padding }), react.createElement(SplitLine
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    , __assign({}, splitLineProps, { key: "".concat(keyRef, "_threshold"), keyRef: "".concat(keyRef, "_threshold"), color: plot.thresholdColor || '#000', area: plot.area }))] }))), jsxRuntime.jsxs("g", __assign({ clipPath: typeof plot.threshold !== 'undefined' && hasThresholdData
                    ? "url(#".concat(plot.key, "_main_clip)")
                    : undefined }, { children: [jsxRuntime.jsx(clipPath.RectClipPath, { id: "".concat(plot.key, "_main_clip"), width: "100%", height: plot.thresholdDirection === 'up' ? '100%' : cutOff + padding, y: plot.thresholdDirection === 'up' ? cutOff + padding : 0 }), react.createElement(SplitLine
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    , __assign({}, splitLineProps, { key: "".concat(keyRef, "_main"), keyRef: "".concat(keyRef, "_main"), color: color, area: plot.area }))] }))] }));
};

function colorByThreshold(value, threshold, thresholdColor, thresholdDirection, fallback) {
    if (thresholdColor === void 0) { thresholdColor = '#000'; }
    if (thresholdDirection === void 0) { thresholdDirection = 'up'; }
    if (fallback === void 0) { fallback = '#000'; }
    if (typeof threshold !== 'undefined') {
        if (valueInThreshold(value, threshold, thresholdDirection)) {
            return thresholdColor;
        }
    }
    return fallback;
}

var Bars = function Bars(_a) {
    var plot = _a.plot, xScale = _a.xScale, yScale = _a.yScale, lastDate = _a.lastDate, _b = _a.index, index = _b === void 0 ? 0 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.barWidth, barWidth = _d === void 0 ? 14 : _d, _e = _a.barPadding, barPadding = _e === void 0 ? 0 : _e;
    return (jsxRuntime.jsx(group.Group, { children: plot.data.map(function (datum, i) {
            // skip last date entry
            if (dateFns.compareAsc(new Date(datum.date), lastDate) === 0)
                return null;
            var barHeight = height - yScale(datum.value);
            var barX = xScale(new Date(datum.date));
            var barY = height - barHeight;
            var color = colorByThreshold(datum.value, plot.threshold, plot.thresholdColor, plot.thresholdDirection, plot.color || colorByIndex(index));
            var x = barX + (barPadding ? barPadding / 2 : 0) - (barWidth / 2);
            var predictionWidth = 3;
            var predictionX = x + (barWidth / 2) - (predictionWidth / 2);
            var barOpacity = function () {
                if (isMissing(datum)) {
                    return 0.3;
                }
                if (isPredicted(datum)) {
                    return 0.6;
                }
                if (typeof plot.barOpacity !== 'undefined') {
                    return plot.barOpacity;
                }
                return 1;
            };
            return (
            // eslint-disable-next-line react/no-array-index-key
            jsxRuntime.jsxs(react.Fragment, { children: [jsxRuntime.jsx(shape.Bar, { x: x, y: barY, width: barWidth - barPadding, height: barHeight, fill: color, fillOpacity: barOpacity() }), isPredicted(datum) && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(shape.Line, { from: { x: predictionX - (barWidth / 2), y: yScale(datum.maxValue) }, to: { x: predictionX + (barWidth / 2), y: yScale(datum.maxValue) }, stroke: "#000", strokeWidth: predictionWidth, strokeOpacity: 1, pointerEvents: "none" }), jsxRuntime.jsx(shape.Line, { from: { x: predictionX, y: yScale(datum.minValue) }, to: { x: predictionX, y: yScale(datum.maxValue) }, stroke: "#000", strokeWidth: predictionWidth, strokeOpacity: 1, pointerEvents: "none" }), jsxRuntime.jsx(shape.Line, { from: { x: predictionX - (barWidth / 2), y: yScale(datum.minValue) }, to: { x: predictionX + (barWidth / 2), y: yScale(datum.minValue) }, stroke: "#000", strokeWidth: predictionWidth, strokeOpacity: 1, pointerEvents: "none" })] }))] }, "".concat(plot.key, "_").concat(i)));
        }) }));
};

var _a$1;
var PREFIX$1 = 'Legend';
var classes$1 = {
    legend: "".concat(PREFIX$1, "-legend"),
    legendItem: "".concat(PREFIX$1, "-legendItem"),
    legendColors: "".concat(PREFIX$1, "-legendColors"),
    legendColor: "".concat(PREFIX$1, "-legendColor"),
    legendMeanLevel: "".concat(PREFIX$1, "-legendMeanLevel"),
    legendColorDashed: "".concat(PREFIX$1, "-legendColorDashed"),
    legendColorBar: "".concat(PREFIX$1, "-legendColorBar"),
    legendWrap: "".concat(PREFIX$1, "-legendWrap"),
    legendPrediction: "".concat(PREFIX$1, "-legendPrediction"),
    legendPredictionLine: "".concat(PREFIX$1, "-legendPredictionLine"),
};
var Root$1 = styles.styled('div')((_a$1 = {},
    _a$1["&.".concat(classes$1.legend)] = {
        display: 'flex',
        position: 'absolute',
        direction: 'ltr',
        fontSize: '0.75em',
        right: 30,
        top: -5,
        alignItems: 'flex-end',
        zIndex: 1,
    },
    _a$1["& .".concat(classes$1.legendItem)] = {
        marginLeft: 8,
        height: 16,
        display: 'flex',
        alignItems: 'center',
    },
    _a$1["& .".concat(classes$1.legendColors)] = {
        width: 15,
        marginRight: 4,
    },
    _a$1["& .".concat(classes$1.legendColor)] = {
        height: 0,
        width: 15,
        marginTop: 3,
        marginBottom: 3,
        border: 0,
        borderTop: '3px solid #fff',
    },
    _a$1["& .".concat(classes$1.legendMeanLevel)] = {
        height: 0,
        width: 0,
        borderTop: '5px solid transparent',
        borderBottom: '5px solid transparent',
        borderLeft: '5px solid red',
        marginRight: 5,
    },
    _a$1["& .".concat(classes$1.legendColorDashed)] = {
        borderColor: 'inherit',
        borderStyle: 'dashed',
    },
    _a$1["& .".concat(classes$1.legendColorBar)] = {
        opacity: 0.5,
    },
    _a$1["& .".concat(classes$1.legendWrap)] = {
        display: 'flex',
    },
    _a$1["& .".concat(classes$1.legendPrediction)] = {
        opacity: 0.6,
    },
    _a$1["& .".concat(classes$1.legendPredictionLine)] = {
        opacity: 0.5,
        margin: 0,
        borderTopWidth: 4.5,
    },
    _a$1));
var Legend = function Legend(_a) {
    var stacked = _a.stacked, series = _a.series, graphHeight = _a.graphHeight, heightWithPadding = _a.heightWithPadding, meanLevel = _a.meanLevel, meanLevelStrokeColor = _a.meanLevelStrokeColor, translations = _a.translations;
    var showLegend = series.every(function (plot) { return !!plot.name; });
    if (!showLegend) {
        return null;
    }
    return (jsxRuntime.jsxs(Root$1, __assign({ className: classNames__default["default"](classes$1.legend, 'GraphLegend'), style: { flexDirection: !stacked ? 'row' : 'column' } }, { children: [typeof meanLevel !== 'undefined' && (jsxRuntime.jsxs("div", __assign({ className: classes$1.legendItem }, { children: [jsxRuntime.jsx("div", { className: classes$1.legendMeanLevel, style: { borderLeftColor: meanLevelStrokeColor } }), jsxRuntime.jsx("div", __assign({ className: classes$1.legendWrap }, { children: jsxRuntime.jsx("div", { children: translations.meanLevel }) }))] }))), series.map(function (plot, index) {
                var _a, _b;
                var plotHeight = stacked && plot.axisHeight
                    ? heightWithPadding(plot.axisHeight) - 16
                    : heightWithPadding(graphHeight) - 16;
                var hasThresholdData = hasValueInThreshold(plot.data, plot.threshold, plot.thresholdDirection);
                var hasMissingData = plot.data.some(isMissing);
                var hasPredictedData = plot.data.some(isPredicted);
                var color = plot.color || colorByIndex(index);
                return (jsxRuntime.jsxs("div", __assign({ className: classes$1.legendWrap }, { children: [jsxRuntime.jsxs("div", __assign({ className: classes$1.legendItem, style: { marginTop: plotHeight } }, { children: [jsxRuntime.jsxs("div", __assign({ className: classes$1.legendColors }, { children: [jsxRuntime.jsx("div", { className: classes$1.legendColor, style: { borderColor: color } }), hasThresholdData && (jsxRuntime.jsx("div", { className: classes$1.legendColor, style: { borderColor: plot.thresholdColor || '#000' } }))] })), jsxRuntime.jsx("div", { children: plot.name })] })), hasMissingData && (jsxRuntime.jsxs("div", __assign({ className: classes$1.legendItem, style: { marginTop: plotHeight } }, { children: [jsxRuntime.jsx("div", __assign({ className: classes$1.legendColors }, { children: jsxRuntime.jsx("div", { style: { borderColor: color }, className: classNames__default["default"](classes$1.legendColor, (_a = {},
                                            _a[classes$1.legendColorDashed] = plot.type !== 'bar',
                                            _a[classes$1.legendColorBar] = plot.type === 'bar',
                                            _a)) }) })), jsxRuntime.jsx("div", { children: translations.missing })] }))), hasPredictedData && (jsxRuntime.jsxs("div", __assign({ className: classes$1.legendItem, style: { marginTop: plotHeight } }, { children: [jsxRuntime.jsxs("div", __assign({ className: classes$1.legendColors }, { children: [jsxRuntime.jsx("div", { style: { borderColor: color }, className: classNames__default["default"](classes$1.legendColor, classes$1.legendPrediction) }), hasThresholdData && (jsxRuntime.jsx("div", { className: classNames__default["default"](classes$1.legendColor, classes$1.legendPrediction, (_b = {},
                                                _b[classes$1.legendPredictionLine] = plot.type === 'line',
                                                _b)), style: { borderColor: plot.thresholdColor || '#000' } }))] })), jsxRuntime.jsx("div", { children: translations.predicted })] })))] }), plot.key));
            })] })));
};

function useSeriesDates(series) {
    return series
        .reduce(function (acc, plot) { return __spreadArray(__spreadArray([], acc, true), plot.data
        // get all dates from data series
        .map(function (datum) { return new Date(datum.date); })
        // filter out the duplicates
        .filter(function (date) { return utilsIsUniqueDate.isUniqueDate(date, acc); }), true); }, []).sort(function (a, b) { return dateFns.compareDesc(a, b); });
}

function useDimensions() {
    var ref = react.useRef(null);
    var _a = react.useState(), dimensions = _a[0], setDimensions = _a[1];
    react.useEffect(function () {
        function handleResize() {
            if (ref.current) {
                var _a = ref.current.getClientRects()[0], width = _a.width, height = _a.height;
                setDimensions({ width: width, height: height });
            }
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return [ref, dimensions || { width: 0, height: 0 }];
}

var Navigation = function Navigation(_a) {
    var width = _a.width, dates = _a.dates, series = _a.series, range = _a.range, setRange = _a.setRange, _b = _a.paddingLeft, paddingLeft = _b === void 0 ? 0 : _b, _c = _a.paddingRight, paddingRight = _c === void 0 ? 0 : _c;
    var brushRef = react.useRef(null);
    var skipChange = react.useRef(false);
    var height = 50;
    var navWidth = Math.max(width - paddingLeft - paddingRight, 0);
    var xScale = createXScale(dates, navWidth);
    var rangeRef = react.useRef([xScale(range[0]), xScale(range[1])]);
    var yScales = react.useMemo(function () { return series.map(function (plot) { return createYScale(plot, height - 4); }); }, [height, series]);
    var initialBrushPosition = react.useMemo(function () { return ({
        start: { x: xScale(range[0]) },
        end: { x: xScale(range[1]) },
    }); }, [range, xScale]);
    react.useEffect(function () {
        rangeRef.current = [xScale(range[0]), xScale(range[1])];
    }, [range, xScale]);
    react.useEffect(function () {
        function handleResize() {
            if (brushRef.current) {
                var updater = function (prevBrush) {
                    if (brushRef.current) {
                        var newExtent = brushRef.current.getExtent({ x: rangeRef.current[0] }, { x: rangeRef.current[1] });
                        var newState = __assign(__assign({}, prevBrush), { start: { y: newExtent.y0, x: newExtent.x0 }, end: { y: newExtent.y1, x: newExtent.x1 }, extent: newExtent, isBrushing: false });
                        return newState;
                    }
                    return prevBrush;
                };
                skipChange.current = true;
                brushRef.current.updateBrush(updater);
            }
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    var onBrushChange = function (domain) {
        if (!domain)
            return;
        if (skipChange.current) {
            skipChange.current = false;
            return;
        }
        var x0 = domain.x0, x1 = domain.x1;
        setRange([x0, x1]);
    };
    if (navWidth === 0) {
        return null;
    }
    return (jsxRuntime.jsxs("svg", __assign({ style: { marginLeft: paddingLeft }, width: navWidth, height: height }, { children: [series.map(function (plot, index) { return (jsxRuntime.jsx(shape.LinePath, { curve: curve.curveBasis, data: plot.data, x: function (datum) { return xScale(new Date(datum.date)); }, y: function (datum) { return yScales[index](datum.value); }, stroke: "#666", strokeWidth: 1, strokeOpacity: 1 }, plot.key)); }), jsxRuntime.jsx(brush.Brush, { xScale: xScale, yScale: yScales[0], width: navWidth, height: height, innerRef: brushRef, handleSize: 8, resizeTriggerAreas: ['left', 'right'], brushDirection: "horizontal", initialBrushPosition: initialBrushPosition, onChange: onBrushChange })] })));
};

var _a;
var PREFIX = 'Graph';
var classes = {
    container: "".concat(PREFIX, "-container"),
    yAxis: "".concat(PREFIX, "-yAxis"),
    yAxisRight: "".concat(PREFIX, "-yAxisRight"),
    graphContainer: "".concat(PREFIX, "-graphContainer"),
    graphContainerNavigation: "".concat(PREFIX, "-graphContainerNavigation"),
    graphLegendContainer: "".concat(PREFIX, "-graphLegendContainer"),
    graph: "".concat(PREFIX, "-graph"),
    legend: "".concat(PREFIX, "-legend"),
    tooltip: "".concat(PREFIX, "-tooltip"),
    tooltipCell: "".concat(PREFIX, "-tooltipCell"),
};
var Root = styles.styled('div')((_a = {},
    _a["& .".concat(classes.container)] = {
        display: 'flex',
    },
    _a["& .".concat(classes.yAxis)] = {
        flexShrink: 0,
        flexGrow: 0,
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    },
    _a["& .".concat(classes.yAxisRight)] = {
        flexShrink: 0,
        flexGrow: 0,
        textAlign: 'right',
    },
    _a["& .".concat(classes.graphContainer)] = {
        maxWidth: '100%',
    },
    _a["& .".concat(classes.graphContainerNavigation)] = {
        overflow: 'visible',
    },
    _a["& .".concat(classes.graphLegendContainer)] = {
        flexShrink: 1,
        flexGrow: 1,
        position: 'relative',
    },
    _a["& .".concat(classes.graph)] = {
        direction: 'ltr',
        display: 'block',
        position: 'relative',
        zIndex: 2,
    },
    _a["& .".concat(classes.legend)] = {
        display: 'flex',
        position: 'absolute',
        direction: 'ltr',
        fontSize: '0.75em',
        right: 30,
        top: -5,
        alignItems: 'flex-end',
        pointerEvents: 'none',
        zIndex: 1,
    },
    _a["& .".concat(classes.tooltip)] = {
        position: 'absolute',
        transform: 'translateY(-50%)',
        fontSize: '0.6em',
        zIndex: 10,
    },
    _a["& .".concat(classes.tooltipCell)] = {
        whiteSpace: 'nowrap',
    },
    _a));
var MeanLevelIndicator = styles.styled('div')({
    position: 'absolute',
    top: 0,
    right: 0,
    display: 'block',
    width: 0,
    height: 0,
    borderTop: '5px solid transparent',
    borderBottom: '5px solid transparent',
    borderLeft: '5px solid red',
    transform: 'translateY(-50%)',
});
var bisectDate = d3Array.bisector(function (d, x) {
    var date = new Date(d.date);
    if (date < x) {
        return 1;
    }
    if (date > x) {
        return -1;
    }
    return 0;
}).right;
var Graph = function Graph(_a) {
    var _b;
    var rawSeries = _a.series, t = _a.t, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.tooltip, tooltip$1 = _d === void 0 ? false : _d, _e = _a.stacked, stacked = _e === void 0 ? false : _e, _f = _a.navigation, navigation = _f === void 0 ? false : _f, _g = _a.lang, lang = _g === void 0 ? 'en' : _g, _h = _a.locale, locale$1 = _h === void 0 ? locale.enUS : _h, now = _a.now, meanLevel = _a.meanLevel, _j = _a.meanLevelStrokeColor, meanLevelStrokeColor = _j === void 0 ? '#b7323f' : _j, onTooltipValueChange = _a.onTooltipValueChange;
    var _k = useDimensions(), ref = _k[0], dimensions = _k[1];
    var series = react.useMemo(function () { return shiftSeriesDates(rawSeries); }, [rawSeries]);
    react.useEffect(function () {
        // set the D3 locale
        d3TimeFormat.timeFormatDefaultLocale(locales[lang]);
    }, [lang]);
    var graphContainerRef = react.useRef(null);
    var tooltipRef = react.useRef(null);
    var _l = react.useState(), tooltipValues = _l[0], setTooltipValues = _l[1];
    var clearTooltip = react.useCallback(function () {
        if (onTooltipValueChange) {
            onTooltipValueChange(null);
        }
        setTooltipValues(undefined);
    }, [onTooltipValueChange]);
    var seriesReversed = react.useMemo(function () { return __spreadArray([], series, true).reverse(); }, [series]);
    var dates = useSeriesDates(series);
    var initialNavStart = dates[Math.ceil(dates.length / 10)];
    var initialNavEnd = dates[0];
    var _m = react.useState([+initialNavStart, +initialNavEnd]), range = _m[0], setRange = _m[1];
    var rangeDates = react.useMemo(function () {
        if (navigation) {
            return dates.filter(function (date) { return +date >= range[0] && +date <= range[1]; });
        }
        return dates;
    }, [dates, navigation, range]);
    var dateFormat = lang === 'nb' ? 'cccccc. d. LLL' : 'ccc, d. LLL';
    var dateFormatWithTime = 'Pp';
    var padding = 30;
    var heightWithPadding = function (inputHeight) { return inputHeight + (padding * 2); };
    var defaultLabelWidth = 44;
    var labelWidth = series[0].labelWidth || defaultLabelWidth;
    var graphDataWidth = react.useMemo(function () { return dimensions.width; }, [dimensions.width]);
    var totalWidth = graphDataWidth - labelWidth - padding;
    var chartTotalHeight = heightWithPadding(height);
    var xScale = createXScale(rangeDates.length >= 2 ? rangeDates : dates, totalWidth);
    var yScales = react.useMemo(function () { return series.map(function (plot) { return createYScale(plot, stacked && plot.axisHeight ? plot.axisHeight : height, padding); }); }, [height, series, stacked]);
    var reversedIndex = function (index) { return seriesReversed.length - index - 1; };
    var handleMouseOver = react.useCallback(function (event$1) {
        // ignore when not using tooltip
        if (!tooltip$1)
            return;
        var coords = event.localPoint(event$1.target, event$1);
        if (coords) {
            var date_1 = xScale.invert(coords.x);
            var values = series.map(function (plot) { return plot.data[bisectDate(plot.data, date_1)]; });
            var xOffset = 10;
            if (graphContainerRef.current && tooltipRef.current) {
                var graphContainerRefBox = graphContainerRef.current.getBoundingClientRect();
                var tooltipBox = tooltipRef.current.getBoundingClientRect();
                if (event$1.clientX + tooltipBox.width + xOffset > graphContainerRefBox.right) {
                    xOffset = (tooltipBox.width + xOffset) * -1;
                }
            }
            if (onTooltipValueChange && values[0]) {
                onTooltipValueChange(values[0].value);
            }
            setTooltipValues(__assign(__assign({}, coords), { values: values, tx: event$1.clientX + xOffset, ty: event$1.clientY + window.scrollY }));
        }
    }, [onTooltipValueChange, series, tooltip$1, xScale]);
    return (jsxRuntime.jsxs(Root, { children: [jsxRuntime.jsxs("div", __assign({ className: classes.container, ref: ref }, { children: [tooltipValues && (tooltipValues === null || tooltipValues === void 0 ? void 0 : tooltipValues.values) && tooltipValues.values[0] && (jsxRuntime.jsx("div", __assign({ ref: tooltipRef, className: classNames__default["default"](classes.tooltip, 'GraphTooltip'), style: __assign(__assign({}, tooltip.defaultStyles), { top: tooltipValues.ty, left: tooltipValues.tx }) }, { children: jsxRuntime.jsx("table", { children: jsxRuntime.jsxs("tbody", { children: [jsxRuntime.jsx("tr", { children: jsxRuntime.jsx("td", __assign({ colSpan: 2 }, { children: dateFns.format(new Date(tooltipValues.values[0].date), dateFormatWithTime, { locale: locale$1 }) })) }, "date"), series.map(function (plot, index) {
                                        var color = typeof plot.threshold !== 'undefined' && valueInThreshold(tooltipValues.values[index].value, plot.threshold, plot.thresholdDirection) ? plot.thresholdColor : plot.color || colorByIndex(index);
                                        if (!tooltipValues.values[index]) {
                                            return null;
                                        }
                                        return (jsxRuntime.jsxs("tr", { children: [jsxRuntime.jsx("td", __assign({ className: classes.tooltipCell, style: { color: color } }, { children: "".concat(plot.name, ":") })), jsxRuntime.jsx("td", __assign({ className: classes.tooltipCell, style: { color: color } }, { children: isMissing(tooltipValues.values[index])
                                                        ? t('missing')
                                                        : tickFormat(plot, tooltipValues.values[index].value) }))] }, plot.key));
                                    })] }) }) }))), jsxRuntime.jsxs("div", __assign({ className: classes.yAxis }, { children: [series.map(function (plot, index) {
                                if (index > 0 && !stacked)
                                    return null;
                                var plotHeight = stacked && plot.axisHeight
                                    ? heightWithPadding(plot.axisHeight)
                                    : chartTotalHeight;
                                return (jsxRuntime.jsx(AxisLeft, { plot: series[index], height: plotHeight, yScale: yScales[index], defaultLabelWidth: defaultLabelWidth }, plot.key));
                            }), typeof meanLevel !== 'undefined' && (jsxRuntime.jsx(MeanLevelIndicator, { style: {
                                    top: yScales[0](meanLevel),
                                    borderLeftColor: meanLevelStrokeColor,
                                } }))] })), jsxRuntime.jsxs("div", __assign({ className: classes.graphLegendContainer }, { children: [jsxRuntime.jsx("div", __assign({ className: classNames__default["default"](classes.graphContainer, (_b = {}, _b[classes.graphContainerNavigation] = navigation, _b), 'GraphContainer'), ref: graphContainerRef, onMouseMove: handleMouseOver, onMouseLeave: clearTooltip }, { children: series.map(function (plot, index) {
                                    if (!stacked && index > 0)
                                        return null;
                                    var columnsHeight = stacked && plot.axisHeight ? plot.axisHeight : height;
                                    return (jsxRuntime.jsxs("svg", __assign({ width: totalWidth, height: heightWithPadding(columnsHeight), className: classes.graph }, { children: [jsxRuntime.jsx(grid.GridRows, { scale: yScales[index], width: graphDataWidth, stroke: "#ccc", strokeOpacity: 0.7 }), jsxRuntime.jsx(grid.GridColumns, { scale: xScale, height: columnsHeight, top: padding, stroke: "#ccc" }), index === 0 && (jsxRuntime.jsx(axis.AxisTop, { top: padding, scale: xScale, tickFormat: function (tick) {
                                                    var date = tick.valueOf();
                                                    if (dateFns.compareDesc(dateFns.startOfDay(date), date) === 0) {
                                                        return dateFns.format(date, dateFormat, { locale: locale$1 });
                                                    }
                                                    return dateFns.format(date, 'p', { locale: locale$1 });
                                                } })), seriesReversed.map(function (innerPlot, i) {
                                                var ri = reversedIndex(i);
                                                if (stacked && index !== ri)
                                                    return null;
                                                var type = innerPlot.type;
                                                var plotHeight = stacked && plot.axisHeight
                                                    ? plot.axisHeight + padding
                                                    : height + padding;
                                                if (type === 'bar') {
                                                    return (jsxRuntime.jsx(Bars, { plot: innerPlot, barWidth: innerPlot.barWidth, barPadding: typeof innerPlot.barPadding !== 'undefined'
                                                            ? innerPlot.barPadding : 4, xScale: xScale, yScale: yScales[ri], height: plotHeight, index: ri, lastDate: dates[0] }, "".concat(innerPlot.key, "_").concat(plot.key)));
                                                }
                                                return (jsxRuntime.jsx(Line, { keyRef: "".concat(innerPlot.key, "_").concat(plot.key), plot: innerPlot, xScale: xScale, yScale: yScales[ri], index: ri }, "".concat(innerPlot.key, "_").concat(plot.key)));
                                            }), tooltipValues && (jsxRuntime.jsx(shape.Line, { from: { x: tooltipValues.x, y: padding }, to: { x: tooltipValues.x, y: columnsHeight + padding }, stroke: "#f00", strokeWidth: 1, strokeOpacity: 0.8, pointerEvents: "none", strokeDasharray: "5,5" })), now && (jsxRuntime.jsx(shape.Line, { from: { x: xScale(now), y: padding }, to: { x: xScale(now), y: columnsHeight + padding }, stroke: "#000", strokeWidth: 1, strokeOpacity: 0.5, pointerEvents: "none", strokeDasharray: "8,8" })), typeof meanLevel !== 'undefined' && (jsxRuntime.jsx(shape.Line, { from: { x: xScale(rangeDates[0]), y: yScales[0](meanLevel) }, to: {
                                                    x: xScale(rangeDates[rangeDates.length - 1]),
                                                    y: yScales[0](meanLevel),
                                                }, stroke: meanLevelStrokeColor, strokeWidth: 1.5, pointerEvents: "none", strokeDasharray: "5,3" }))] }), "".concat(plot.key, "_").concat(stacked ? 'stacked' : 'combined')));
                                }) })), jsxRuntime.jsx(Legend, { stacked: stacked, series: series, graphHeight: height, heightWithPadding: heightWithPadding, meanLevel: meanLevel, meanLevelStrokeColor: meanLevelStrokeColor, translations: {
                                    missing: t('missing'),
                                    predicted: t('predicted'),
                                    meanLevel: t('mean_level'),
                                } })] })), series.length > 1 && (jsxRuntime.jsx("div", __assign({ className: classes.yAxisRight }, { children: series.map(function (plot, index) { return (stacked || index === 0 ? null : (jsxRuntime.jsx("svg", __assign({ width: plot.labelWidth || defaultLabelWidth, height: chartTotalHeight }, { children: jsxRuntime.jsx(axis.AxisRight, { scale: yScales[index], tickFormat: function (tick) { return tickFormat(plot, tick.valueOf()); }, stroke: plot.color || colorByIndex(index), tickStroke: plot.color || colorByIndex(index), tickLabelProps: function () { return ({
                                    fill: plot.color || colorByIndex(index),
                                    fontSize: 10,
                                    x: 10,
                                    textAnchor: 'start',
                                    verticalAnchor: 'middle',
                                }); } }) }), plot.key))); }) })))] })), navigation && (jsxRuntime.jsx("div", { children: jsxRuntime.jsx(Navigation, { dates: dates, width: dimensions.width, series: seriesReversed, paddingLeft: labelWidth, paddingRight: padding, range: range, setRange: setRange }) }))] }));
};

exports.Graph = Graph;
exports.createXScale = createXScale;
exports.createYScale = createYScale;
exports.isMissing = isMissing;
exports.isPredicted = isPredicted;
exports.shiftDate = shiftDate;
exports.useDimensions = useDimensions;
exports.useSeriesDates = useSeriesDates;
